"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReleaseNotesBrief = buildReleaseNotesBrief;
const derived_1 = require("./derived");
/**
 * Build the release-notes brief from state. `titlesOnly` skips done-body hydration for a fast,
 * low-token draft; the default hydrates each Unreleased plan's done-doc body. Pure.
 */
function buildReleaseNotesBrief(state, opts = {}) {
    const titlesOnly = opts.titlesOnly === true;
    const { roadmap, history } = (0, derived_1.buildRoadmap)(state);
    // Index done-doc bodies by the plan they record, for hydration.
    const doneBodyByPlan = new Map();
    if (!titlesOnly) {
        for (const weave of state.weaves ?? []) {
            for (const thread of weave.threads ?? []) {
                for (const done of thread.dones ?? []) {
                    if (done.parent_id && typeof done.content === 'string') {
                        doneBodyByPlan.set(done.parent_id, done.content);
                    }
                }
            }
        }
    }
    // history is already newest-first; the Unreleased set is release == null.
    const unreleased = history
        .filter(h => h.release == null)
        .map(h => ({
        planId: h.planId,
        planTitle: h.planTitle,
        weaveSlug: h.weaveSlug,
        threadSlug: h.threadSlug,
        date: h.date,
        doneBody: titlesOnly ? undefined : doneBodyByPlan.get(h.planId),
    }));
    const implementingThreads = roadmap
        .filter(n => n.status === 'implementing')
        .map(n => ({ weaveSlug: n.weaveSlug, threadSlug: n.threadSlug, title: n.title }));
    return {
        unreleased,
        implementingThreads,
        isEmpty: unreleased.length === 0,
        enriched: !titlesOnly,
    };
}
